import { render, staticRenderFns } from "./newPresentationGazSansAssocie.vue?vue&type=template&id=28062604"
import script from "./newPresentationGazSansAssocie.vue?vue&type=script&lang=js"
export * from "./newPresentationGazSansAssocie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports